// Generic fuzzy-ish search helper.
// items: array of data objects
// term: search string
// fieldGetters: array of functions that return strings/numbers to search against
export function filterBySearch(items = [], term = "", fieldGetters = []) {
  if (!term) return items;
  const needle = term.toLowerCase();

  return items.filter((item) =>
    fieldGetters.some((fn) => {
      try {
        const val = fn(item);
        if (val === undefined || val === null) return false;
        return String(val).toLowerCase().includes(needle);
      } catch {
        return false;
      }
    })
  );
}

export default filterBySearch;
